import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { http } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

const MAX_POLL = 8;

export function BillingSuccess() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const [state, setState] = useState("polling"); // polling | paid | timeout
  const sessionId = sp.get("session_id");

  useEffect(() => {
    try { sessionStorage.removeItem("nm:pending-checkout"); } catch { /* ignore */ }
    if (!sessionId) { setState("timeout"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const r = await http.get(`/billing/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setState("paid"); return; }
      } catch { /* ignore */ }
      tries += 1;
      if (tries >= MAX_POLL) { setState("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#0B1120] text-slate-100 flex items-center justify-center p-6" data-testid="billing-success">
      <div className="max-w-md w-full text-center space-y-4">
        {state === "polling" && <><Loader2 className="w-14 h-14 text-sky-400 mx-auto animate-spin" /><h1 className="font-heading text-2xl font-extrabold">{t("billing.processing")}</h1></>}
        {state === "paid" && <><CheckCircle2 className="w-14 h-14 text-emerald-400 mx-auto" /><h1 className="font-heading text-2xl font-extrabold">{t("billing.success_title")}</h1><p className="text-slate-400">{t("billing.success_sub")}</p></>}
        {state === "timeout" && <><Loader2 className="w-14 h-14 text-amber-400 mx-auto" /><h1 className="font-heading text-2xl font-extrabold">{t("billing.processing")}</h1></>}
        <Button data-testid="success-dashboard-btn" onClick={() => nav("/")} className="bg-sky-500 hover:bg-sky-400 text-[#0B1120] font-semibold">{t("billing.go_dashboard")}</Button>
      </div>
    </div>
  );
}

export function BillingCancel() {
  const { t } = useTranslation();
  const nav = useNavigate();
  useEffect(() => { try { sessionStorage.removeItem("nm:pending-checkout"); } catch { /* ignore */ } }, []);
  return (
    <div className="min-h-screen bg-[#0B1120] text-slate-100 flex items-center justify-center p-6" data-testid="billing-cancel">
      <div className="max-w-md w-full text-center space-y-4">
        <XCircle className="w-14 h-14 text-slate-400 mx-auto" />
        <h1 className="font-heading text-2xl font-extrabold">{t("billing.cancelled_title")}</h1>
        <p className="text-slate-400">{t("billing.cancelled_sub")}</p>
        <Button data-testid="cancel-back-btn" onClick={() => nav("/impostazioni?tab=abbonamento")} className="bg-sky-500 hover:bg-sky-400 text-[#0B1120] font-semibold">{t("billing.back_plans")}</Button>
      </div>
    </div>
  );
}
